import { Button } from '@components/buttons';
import { BaseDialog } from '@components/dialog';
import { showModalForm } from '@components/modal-form';
import { useAsyncData } from 'client/lib/hooks';
import { rpx } from 'client/lib/rpx-client';
import dayjs from 'dayjs';
import { RuzcalFormQuestion, State } from './types';
import { CalendarForm } from '@components/calendar-form';

type FormData = {
  id: string;
  name: string;
  description: string;
  questions: RuzcalFormQuestion[];
};

type ResponsesModaProps = {
  form: FormData;
  userId?: string;
  eventId?: string;
  close(): void;
};

function ResponsesModal({ form, userId, eventId, close }: ResponsesModaProps) {
  return (
    <BaseDialog onClose={close} contentWidth>
      <section class="flex flex-col sm:gap-6 gap-10 sm:p-10 sm:w-2xl lg:w-4xl max-w-screen overflow-auto">
        <CalendarForm form={form} eventId={eventId} userId={userId} readonly />
      </section>
    </BaseDialog>
  );
}

type Props = {
  form: State;
};

export function ResponsesTab({ form }: Props) {
  const { data: responses } = useAsyncData(async () => {
    const responses = await rpx.ruzcalForms.getFormResponses({
      formId: form.id,
    });
    return responses;
  }, [form.id]);

  return (
    <div class="flex flex-col divide-y">
      {responses?.map((r) => {
        const day = dayjs(r.submittedAt);
        return (
          <section key={r.id} class="flex gap-2 p-4 items-start">
            <span class="w-32 flex items-center gap-2">
              <span class="font-medium text-lg rounded-full size-8 flex items-center justify-center hover:bg-gray-200">
                {day.format('D')}
              </span>
              <span>{day.format('MMM, ddd')}</span>
            </span>
            <div class="flex flex-col gap-4 md:gap-2 grow">
              <span class="font-semibold flex flex-wrap gap-2">
                <Button
                  onClick={() => {
                    showModalForm(({ resolve }) => (
                      <ResponsesModal
                        form={{
                          id: form.id,
                          name: form.name,
                          description: form.description,
                          questions: form.questions,
                        }}
                        userId={r.userId}
                        eventId={r.eventId}
                        close={resolve}
                      />
                    ));
                  }}
                >
                  {r.username} has filled in the form for event type {r.name}
                </Button>
              </span>
            </div>
          </section>
        );
      })}
    </div>
  );
}
